<template>
  <v-dialog v-model="dialog.value" max-width="500">
    <template v-slot:activator="{ on: modelOn }">
      <v-tooltip bottom dark>
        <template v-slot:activator="{ on: tooltipOn }">
          <v-btn icon v-on="{ ...modelOn, ...tooltipOn }">
            <v-icon>mdi-account-multiple-remove</v-icon>
          </v-btn>
        </template>
        <span>Powróć do własnego konta</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar color="warning" dark flat>
        <v-toolbar-title>Ostrzeżenie</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-4">
        <p>Czy na pewno chcesz anulować przeglądanie jako inne konto?</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn class="text--secondary" text :disabled="dialog.loading" @click="dialog.value = false">Nie</v-btn>
        <v-btn color="warning" text :loading="dialog.loading" @click="unImpersonateUser">Tak</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState } = createNamespacedHelpers('account');

export default {
  data: function() {
    return {
      dialog: {
        value: false,
        loading: false
      }
    };
  },
  computed: {
    ...mapState(['impersonation']),
    'dialog.loading'() {
      return this.impersonation.isImpersonated.loading;
    }
  },
  methods: {
    ...mapActions(['unImpersonate']),
    async unImpersonateUser() {
      this.dialog.loading = true;
      await this.unImpersonate();

      try {
        await this.$router.replace('/');
        this.dialog.value = false;
        this.dialog.loading = false;
      } catch (e) {
        // can replace with same path
        this.$router.go();
      }
    }
  }
};
</script>

<style scoped></style>
